// extracted by mini-css-extract-plugin
module.exports = {"pdf_btn":"button_pdf_btn__3z7L7","active":"button_active__2xuTE","close":"button_close__f6ixj","file_wrapper":"button_file_wrapper__NagvW"};